import { useQuery, UseQueryOptions } from 'react-query'
import { getClientId } from 'utils/getClientId'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { PetAttempt } from '../mutations/useSubmitPetAttempt'

export namespace FetchPetAttempt {
  export type Response = PetAttempt
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (ownerId: string) => ['pet-attempt', { ownerId }]

const queryFetcher = (ownerId: string) => () => {
  return ApiClient.get<FetchPetAttempt.Response>(`/v1/pet-attempts/${ownerId}`)
}

export const useFetchPetAttempt = (options?: FetchPetAttempt.Options) => {
  const ownerId = getClientId() || ''
  return useQuery<FetchPetAttempt.Response, FetchPetAttempt.Error>(
    createKey(ownerId),
    queryFetcher(ownerId),
    { ...options, enabled: options?.enabled && Boolean(ownerId) }
  )
}

// Only uncomment this method if you want to prefetch data in getStaticProps or
// getServerSide props. This method will load the data on the server and hydrate it
// once the client JS loads.
//
// https://react-query.tanstack.com/guides/ssr#using-hydration

// export const prefetchFetchPetAttempt = async (options?: FetchPetAttempt.Options) => {
//   const queryClient = new QueryClient()

//   await queryClient.prefetchQuery<FetchPetAttempt.Response, FetchPetAttempt.Error>(
//     createKey(),
//     queryFetcher(),
//     options
//   )

//   return {
//     dehydratedState: dehydrate(queryClient),
//   }
// }
